// Plan price qualifiers carry their fine print marked with **…** — the keyed
// copy in backend/i18n is "per work **(registration fee)**". Products whose
// Stripe metadata predates the marker spell the qualifier out, so a trailing
// "(registration fee)" is recognised too.
const FINE_SEGMENT = /\*\*(.+?)\*\*|\(registration fee\)/g
const TRAILING_FINE = /^(.*?)\s*(?:\*\*(.+?)\*\*|(\([^)]*\)))\s*$/

// Inline: every marked segment becomes fine print within the surrounding text.
export const renderFine = (text: string) =>
  text.replace(
    FINE_SEGMENT,
    (match, marked) =>
      `<span class="text-[13px] leading-[17px] font-normal italic">${marked ?? match}</span>`
  )

// Split: the trailing marked segment becomes its own element, so a caller can
// size the label and the fine print independently.
export const splitFine = (text: string) => {
  const match = text.match(TRAILING_FINE)
  if (!match) return { label: text, fine: '' }
  return { label: match[1], fine: match[2] ?? match[3] ?? '' }
}
